app.factory("InfoPopoverHover", [
	"$timeout",
	function ($timeout) {
		var POPOVER_HOVER_DELAY_MS = 500;
		var POPOVER_CLOSE_DELAY_MS = 150;

		function removeAppendedInfoPopovers() {
			var popovers = document.querySelectorAll(".popover.info-detail-popover");
			for (var i = 0; i < popovers.length; i++) {
				angular.element(popovers[i]).remove();
			}
		}

		function findActiveInfoPopoverElement() {
			var popovers = document.querySelectorAll(".popover.info-detail-popover");
			for (var i = popovers.length - 1; i >= 0; i--) {
				var el = popovers[i];
				if (el.classList.contains("in") || el.offsetWidth > 0) {
					return el;
				}
			}
			return null;
		}

		function attach($scope, options) {
			options = options || {};

			var getIdPart =
				options.getIdPart ||
				function (item) {
					if (!item) {
						return "item";
					}
					if (item.diagnosis_id != null) {
						return "diagnosis-" + item.diagnosis_id;
					}
					if (item.medication_id != null) {
						return "medication-" + item.medication_id;
					}
					return "item";
				};

			var popoverHoverTimer = null;
			var popoverCloseTimer = null;
			var hoverTargetKey = null;
			var popoverElementListeners = null;
			var hoverAnchorEl = null;

			$scope.activePopoverKey = null;

			function getInfoPopoverKey(item, side, rowIndex) {
				if (!item) {
					return null;
				}
				return getIdPart(item) + "-" + side + "-" + rowIndex;
			}

			function unbindPopoverElementListeners() {
				if (popoverElementListeners) {
					popoverElementListeners.element.off("mouseenter", popoverElementListeners.onEnter);
					popoverElementListeners.element.off("mouseleave", popoverElementListeners.onLeave);
					popoverElementListeners = null;
				}
			}

			function bindPopoverElementListeners(attempt) {
				unbindPopoverElementListeners();
				var popoverEl = findActiveInfoPopoverElement();
				if (!popoverEl || !$scope.activePopoverKey) {
					if ((attempt || 0) < 8) {
						$timeout(function () {
							bindPopoverElementListeners((attempt || 0) + 1);
						}, 50);
					}
					return;
				}

				var element = angular.element(popoverEl);
				var onEnter = function () {
					$scope.$apply(function () {
						$scope.cancelInfoPopoverClose();
					});
				};
				var onLeave = function () {
					$scope.$apply(function () {
						$scope.scheduleInfoPopoverClose();
					});
				};

				element.on("mouseenter", onEnter);
				element.on("mouseleave", onLeave);
				popoverElementListeners = { element: element, onEnter: onEnter, onLeave: onLeave };
			}

			function shouldRepositionWithResize() {
				return !(hoverAnchorEl && hoverAnchorEl.closest && hoverAnchorEl.closest(".modal"));
			}

			function openInfoPopover(item, key) {
				$scope.object = item;
				$scope.activePopoverKey = key;
				$timeout(function () {
					if (shouldRepositionWithResize()) {
						angular.element(window).trigger("resize");
					}
					bindPopoverElementListeners(0);
				}, 0);
			}

			function isMovingToAnotherHoverRow($event) {
				if (!$event || !$event.relatedTarget) {
					return false;
				}
				return angular.element($event.relatedTarget).closest(".diagnosis-row-hover").length > 0;
			}

			$scope.isInfoPopoverOpen = function (item, side, rowIndex) {
				return $scope.activePopoverKey === getInfoPopoverKey(item, side, rowIndex);
			};

			$scope.cancelInfoPopoverClose = function () {
				if (popoverCloseTimer) {
					$timeout.cancel(popoverCloseTimer);
					popoverCloseTimer = null;
				}
			};

			$scope.scheduleInfoPopoverClose = function () {
				$scope.cancelInfoPopoverClose();
				popoverCloseTimer = $timeout(function () {
					if (hoverTargetKey) {
						return;
					}
					$scope.activePopoverKey = null;
					popoverCloseTimer = null;
					unbindPopoverElementListeners();
					$timeout(removeAppendedInfoPopovers, 200);
				}, POPOVER_CLOSE_DELAY_MS);
			};

			$scope.onInfoIconEnter = function (item, side, rowIndex, $event) {
				var key = getInfoPopoverKey(item, side, rowIndex);
				hoverTargetKey = key;

				if ($event && $event.currentTarget) {
					hoverAnchorEl = $event.currentTarget;
				}

				$scope.cancelInfoPopoverTimer();
				$scope.cancelInfoPopoverClose();

				if ($scope.activePopoverKey && $scope.activePopoverKey !== key) {
					openInfoPopover(item, key);
					return;
				}

				if ($scope.activePopoverKey === key) {
					return;
				}

				popoverHoverTimer = $timeout(function () {
					if (hoverTargetKey !== key) {
						return;
					}
					openInfoPopover(item, key);
					popoverHoverTimer = null;
				}, POPOVER_HOVER_DELAY_MS);
			};

			$scope.onInfoIconLeave = function ($event) {
				if (isMovingToAnotherHoverRow($event)) {
					return;
				}

				$scope.cancelInfoPopoverTimer();
				hoverTargetKey = null;

				if ($scope.activePopoverKey) {
					$scope.scheduleInfoPopoverClose();
				}
			};

			$scope.cancelInfoPopoverTimer = function () {
				if (popoverHoverTimer) {
					$timeout.cancel(popoverHoverTimer);
					popoverHoverTimer = null;
				}
			};

			$scope.closeInfoPopover = function () {
				hoverTargetKey = null;
				hoverAnchorEl = null;
				$scope.cancelInfoPopoverTimer();
				$scope.cancelInfoPopoverClose();
				$scope.activePopoverKey = null;
				unbindPopoverElementListeners();
				removeAppendedInfoPopovers();
				$timeout(removeAppendedInfoPopovers, 200);
			};

			var destroyDeregister = $scope.$on("$destroy", function () {
				$scope.closeInfoPopover();
				destroyDeregister();
			});
		}

		/**
		 * Attaches a hover-delay open / close-delay close pattern to $scope.
		 *
		 * Options:
		 *   isOpenKey   {string}   Dot-notation path on $scope that controls the
		 *                          popover open state, e.g. "popoverOpen" or
		 *                          "navSearch.open".  Required.
		 *   onEnterKey  {string}   Name of the enter handler function placed on
		 *                          $scope (default "onHoverPopoverEnter").
		 *   onLeaveKey  {string}   Name of the leave handler function placed on
		 *                          $scope (default "onHoverPopoverLeave").
		 *   onHoverStart {fn}      Called each time the mouse enters (e.g. to
		 *                          pre-fetch data).
		 *   openDelay   {number}   ms before the popover opens (default 500).
		 *   closeDelay  {number}   ms grace period before closing — use > 0 when
		 *                          there is a visual gap between the trigger and
		 *                          the popover content (default 0).
		 *
		 * Example (inside any controller):
		 *
		 *   $scope.myState = { open: false };
		 *
		 *   InfoPopoverHover.attachDelayedPopover($scope, {
		 *     isOpenKey:   "myState.open",
		 *     onEnterKey:  "onMyPopoverEnter",
		 *     onLeaveKey:  "onMyPopoverLeave",
		 *     openDelay:   500,
		 *     closeDelay:  250,
		 *   });
		 *
		 * In the template:
		 *   <li ng-mouseenter="onMyPopoverEnter()" ng-mouseleave="onMyPopoverLeave()">
		 *     <div uib-popover-template="..." popover-is-open="myState.open">
		 */
		function attachDelayedPopover($scope, options) {
			options = options || {};

			var isOpenKey = options.isOpenKey || "hoverPopoverOpen";
			var onEnterKey = options.onEnterKey || "onHoverPopoverEnter";
			var onLeaveKey = options.onLeaveKey || "onHoverPopoverLeave";
			var onHoverStart = options.onHoverStart;
			var openDelay = options.openDelay != null ? options.openDelay : POPOVER_HOVER_DELAY_MS;
			var closeDelay = options.closeDelay != null ? options.closeDelay : 0;

			// Support dot-notation paths like "navSearch.open" so that object
			// properties shared across ng-if child scopes work correctly.
			var keyParts = isOpenKey.split(".");

			function getIsOpen() {
				var val = $scope;
				for (var i = 0; i < keyParts.length; i++) {
					if (val == null) {
						return false;
					}
					val = val[keyParts[i]];
				}
				return !!val;
			}

			function setIsOpen(val) {
				var obj = $scope;
				for (var i = 0; i < keyParts.length - 1; i++) {
					obj = obj[keyParts[i]];
				}
				obj[keyParts[keyParts.length - 1]] = val;
			}

			var openTimer = null;
			var closeTimer = null;
			// True for a short window after the close timer fires so that
			// re-entry across the trigger→popover gap re-opens immediately
			// instead of making the user wait through the full openDelay again.
			var justClosedByTimer = false;
			var justClosedResetTimer = null;

			function cancelOpenTimer() {
				if (openTimer) {
					$timeout.cancel(openTimer);
					openTimer = null;
				}
			}

			function cancelCloseTimer() {
				if (closeTimer) {
					$timeout.cancel(closeTimer);
					closeTimer = null;
				}
			}

			function closePopover() {
				cancelOpenTimer();
				cancelCloseTimer();
				justClosedByTimer = false;
				if (justClosedResetTimer) {
					$timeout.cancel(justClosedResetTimer);
					justClosedResetTimer = null;
				}
				setIsOpen(false);
			}

			$scope[onEnterKey] = function () {
				cancelCloseTimer();

				if (typeof onHoverStart === "function") {
					onHoverStart();
				}

				if (getIsOpen() || openTimer) {
					return;
				}

				// If the close timer fired very recently (mouse crossed the gap
				// slower than closeDelay), skip the open delay so the popover
				// snaps back open without making the user wait again.
				var delay = justClosedByTimer ? 0 : openDelay;
				justClosedByTimer = false;

				openTimer = $timeout(function () {
					openTimer = null;
					setIsOpen(true);
				}, delay);
			};

			$scope[onLeaveKey] = function () {
				cancelOpenTimer();

				if (!getIsOpen()) {
					return;
				}

				if (closeDelay > 0) {
					cancelCloseTimer();
					closeTimer = $timeout(function () {
						closeTimer = null;
						setIsOpen(false);
						// Mark as just-closed so immediate re-entry re-opens fast.
						// Reset the flag after a generous window so a completely
						// fresh hover later still gets the normal open delay.
						justClosedByTimer = true;
						if (justClosedResetTimer) {
							$timeout.cancel(justClosedResetTimer);
						}
						justClosedResetTimer = $timeout(function () {
							justClosedResetTimer = null;
							justClosedByTimer = false;
						}, 1000);
					}, closeDelay);
				} else {
					setIsOpen(false);
				}
			};

			var destroyDeregister = $scope.$on("$destroy", function () {
				closePopover();
				if (justClosedResetTimer) {
					$timeout.cancel(justClosedResetTimer);
					justClosedResetTimer = null;
				}
				destroyDeregister();
			});
		}

		return {
			attach: attach,
			attachDelayedPopover: attachDelayedPopover,
		};
	},
]);
